<template>
  <div>
    <div id="searcher">
      <div class="wrapper">
        <div class="search-box ">
          <div class="search-text">
            <h2>轻便研究 高校导航</h2>
          </div>
          <el-input placeholder="请输入检索词"
                    v-model="searchInput"
                    class="search-input"
                    @keyup.enter.native="handleSearch">
            <el-button class="search-input_button"
                       slot="append"
                       @click="handleSearch">检索</el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div id="body">
      <section>
        <div class="ibox">
          <div class="ibox_content">
            <div class="guid-tabs g-school">
              <div class="guid-tabs_content show-more"
                   v-loading="schoolLoading">
                <div class="guid-content">
                  <div class="guid-school-list">
                    <el-skeleton :loading="schoolLoading"
                                 :count="20"
                                 animated>
                      <template slot="template">
                        <dl>
                          <dd class="pic">
                            <el-skeleton-item variant="image"
                                              style="width: 95px" />
                          </dd>
                          <dt class="name">
                            <el-skeleton-item variant="h2"
                                              style="width: 50%" />

                          </dt>

                        </dl>
                      </template>
                      <template>

                        <dl v-for="(item, index) in schoolList"
                            :key="index">
                          <dd class="pic">
                            <!-- <img :src="item.logo" :alt="item.name" /> -->
                            <router-link :to="'/school/detail?id=' + item.id">
                              <el-image :src="item.logo">
                                <div slot="error"
                                     class="image-slot">
                                  <i class="el-icon-picture-outline"></i>
                                </div>
                              </el-image>
                            </router-link>
                          </dd>
                          <dt class="name">
                            <router-link :to="'/school/detail?id=' + item.id">
                              {{ item.name }}
                            </router-link>
                          </dt>
                        </dl>
                      </template>
                    </el-skeleton>

                  </div>
                  <div class="search-bottom">
                    <div class="search-page-total">
                      共 {{ total > 10000 ? "10000+" : total }} 条 第
                      {{ pageIndex }}/{{
                        pageCount > 1000 ? "1000+" : pageCount
                      }}页
                    </div>
                    <div class="search-page">
                      <el-pagination :current-page="pageIndex"
                                     :page-size="pageSize"
                                     layout=" prev,pager,next,jumper"
                                     :total="total"
                                     @current-change="handleCurrentPageChange">
                      </el-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { axiosOptions, axiosRequest } from "../../util/request";
import moment from "moment";
import { cutstr } from "../../util/utils";

export default {
  data () {
    return {
      searchInput: "",
      schoolList: [],
      schoolLoading: false,
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      pageCount: 0,
    };
  },
  created () {
    this.handleSearch();
  },
  mounted () { },
  methods: {
    handleCurrentPageChange (currentPage) {
      this.pageIndex = currentPage;
      this.getPagedList(false);
    },
    handleSearch () {
      this.getPagedList(true);
    },
    getPagedList (resetPageIndex) {
      if (resetPageIndex) {
        this.pageIndex = 1;
      }

      this.schoolLoading = true;
      axiosRequest(
        "/school/paged-list",
        {
          name: this.searchInput,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          this.schoolLoading = false;
          if (res.data && res.data.code === 200) {
            this.schoolList = res.data.data.records;
            this.total = res.data.data.total;
            this.pageCount = res.data.data.pages;
          }
        })
        .catch(() => {
          this.schoolLoading = false;
        });
    },
    cutstring (str, len) {
      return cutstr(str, len);
    },
    dateFormat (cellValue) {
      if (!cellValue) return "";
      // return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
      return moment(cellValue).format("YYYY-MM-DD");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/web.scss";
@import "@/assets/css/search.scss";

.guid-tabs {
  &_content {
    max-height: inherit;
    min-height: inherit;
    padding: 20px 0;
    &:after {
      display: none;
    }
  }
}
.guid-content {
  max-height: inherit;
  min-height: inherit;
  .guid-class-list {
    width: 100%;
    height: auto;
    margin-left: 0;

    .guid-info {
      position: relative;
      left: 0;
      top: 0;
      float: left;
      width: 25%;
      height: 342px;
    }
    dl {
      position: relative;
      width: calc(100% / 4);
      vertical-align: top;
    }
  }

  ::v-deep .guid-school-list {
    .pic {
      .el-image__inner {
        max-height: 100px;
      }
    }
  }

  .search-bottom {
    margin-top: 20px;
    margin-bottom: 0;
    font-size: 14px;
    @media screen and (max-width: 768px) {
      padding: 0 15px;
    }
    ::v-deep .el-pagination {
      .el-pagination__total:before {
        background-color: #c9e4ed;
      }
      .el-pager li {
        display: inline-block;
      }
      .el-pager li.active {
        margin-left: 5px !important;
      }
    }
  }
}
</style>
